module.exports = __webpack_public_path__ + "media/images/experts_sidebar-c25eaeb0b071c0c755c949f40bbbb120.jpg";